import React from "react";
//import ReactPlaceholder from 'react-placeholder';
//import 'react-placeholder/lib/reactPlaceholder.css';

const Loading = ({ size, weight, className, color }) => (
	<div className={className ? className : ""}>
		<div className={`spinner-border text-primary`} role="status"></div>
		<style jsx>{`
			.spinner-border {
				width: ${size ? size : "2rem"} !important;
				height: ${size ? size : "2rem"} !important;
				font-size: ${weight ? weight : "18px"} !important;
				color: ${color ? color : "white"} !important;
			}
		`}</style>
	</div>
);

export default Loading;
